export enum MsisdnRequiredness {
  ABSENT,
  NON_VERIFIED, // non-verified is different than unverified, because we don't even try.
  OPTIONAL,
  REQUIRED,
}
